import { Chip } from '@mui/material';
import dayjs from 'dayjs';
import { FilterChipActions, FilterItem } from './types';

type AssetFilterValue = {
  id: string;
  assetName: string;
};

export const renderDateRangeChip = (filter: FilterItem, actions?: FilterChipActions) => {
  const filterDates = filter.value as [string, string];

  return (
    <Chip
      size="small"
      color="primary"
      key={`${filter.name}`}
      label={`${dayjs(filterDates[0]).format('YYYY-MM-DD')} - ${dayjs(filterDates[1]).format(
        'YYYY-MM-DD'
      )}`}
      onDelete={() => {
        actions?.removeFilter(filter.name);
      }}
    />
  );
};

export const renderAssetsChips = (filter: FilterItem, actions?: FilterChipActions) => {
  if (!Array.isArray(filter.value) || !filter.value.length) return <></>;

  const assets = filter.value as unknown as AssetFilterValue[];

  return assets.map((asset) => (
    <Chip
      size="small"
      color="primary"
      key={`${filter.name} - ${asset}`}
      label={asset.assetName}
      onDelete={() => {
        actions?.removeFilter(filter.name, (currentValue) =>
          Array.isArray(currentValue)
            ? ((currentValue as unknown as AssetFilterValue[]).filter(
                (el) => el.id !== asset.id
              ) as unknown as FilterItem['value'])
            : currentValue
        );
      }}
    />
  ));
};

export const createTextChipRenderer =
  (label: string) => (filter: FilterItem, actions?: FilterChipActions) =>
    (
      <Chip
        size="small"
        color="primary"
        key={`${filter.name}`}
        label={label}
        onDelete={() => {
          actions?.removeFilter(filter.name);
        }}
      />
    );
